module.exports = __webpack_public_path__ + "static/media/Philadelphia_Flyers.ab670883.svg";